module.exports = __webpack_public_path__ + "static/media/auli.046cb04d.png";